<template>
  <!-- 出入金明细列表 -->
  <div class="opage">
    <div>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 开始日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container"
              type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
              default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
            </el-date-picker>
          </div>
          <!-- 账单类型 -->
          <div class="item">
            <el-select v-model='datas.bill_type' :placeholder="$t('message.billingType')" filterable clearable>
              <el-option v-for=' item in billType' :key='item.key' :label='item.value' :value='item.key'>
              </el-option>
            </el-select>
          </div>
          <!-- 交易方式 -->
          <div class="item">
            <el-select v-model='datas.bill_method' :placeholder="$t('message.transactionWay')" filterable clearable>
              <el-option v-for=' item in billMethod' :key='item.key' :label='item.value' :value='item.key'>
              </el-option>
            </el-select>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.search") }}
          </el-button>
          <!-- 重置 -->
          <el-button @click="reset">
            {{ $t("message.reset") }}
          </el-button>
        </div>
      </div>
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 提出时间 -->
          <li>{{ $t('message.forwardTime') }}</li>
          <!-- 注文書・配送書 -->
          <li class="flex2">{{ $t('message.noteDocumentsdeliveryBooks') }}</li>
          <!-- 内容 -->
          <li class="flex3">{{ $t('message.content') }}</li>
          <!-- 账单类型 -->
          <li>{{ $t('message.billingType') }}</li>
          <!-- 交易方式 -->
          <li>{{ $t('message.transactionWay') }}</li>

          <!-- 出入金金额 -->
          <li>出金额 </li>
          <!-- 出入金金额 -->
          <li>入金额 </li>
          <!-- 残金 -->
          <li>{{ $t('message.residualGold') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">{{ index + 1 }}</li>
          <!-- 提出时间 -->
          <li>{{ item.created_at }}</li>
          <!-- 注文書・配送書 -->
          <li class="flex2">
            <div v-if="item.order_sn">
              <!-- 2023/2/22 大榭说配送单号和订单号都用这个参数 -->
              <p>
                <!-- 配送单详情链接 -->
                {{ item.order_sn.substr(0, 1) == 'P' ? '配送書' : '注文書' }} <router-link
                  v-if="item.order_sn.substr(0, 1) == 'P'" class="redFont"
                  :to="'/porderDetail?is_japanfirm=1&porder_sn=' + item.order_sn" target="_blank">
                  {{ item.order_sn }}
                </router-link>
                <!-- 订单详情链接 -->
                <router-link v-else class="redFont" :to="'/orderPaymentDetail?is_japanfirm=1&order_sn=' + item.order_sn"
                  target="_blank">
                  {{ item.order_sn }}
                </router-link>
              </p>
            </div>
          </li>
          <!-- 内容 -->
          <li class="flex3">
            <div v-if="item.adjust_detail != false && item.adjust_detail != null" class="showDetail">
              <div style=" overflow: hidden;">
                <p v-for="(item, index) in  item.adjust_detail[0]" :key="index">
                  {{ item }}
                </p>
              </div>
            </div>
          </li>
          <!-- 账单类型 -->
          <li>{{ item.bill_type_name }}</li>
          <!-- 交易方式 -->
          <li>{{ item.bill_method_name }}</li>
          <!-- 出入金金额 -->
          <li>{{ item.bill_type_group == '出金' ? item.amount : '' }} </li>
          <!-- 出入金金额 -->
          <li>{{ item.bill_type_group == '入金' ? item.amount : '' }} </li>
          <!-- 残金 -->
          <li>{{ item.balance }}</li>
        </ul>
        <div v-if="tableData == false" class="No_data">暂无数据</div>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    user_id: { type: Number }
  },
  data() {
    return {
      datas: {
        user_id: '',
      },
      tableData: [],
      total: 0,
      billType: [],
      billMethod: []
    };
  },
  component: {},
  created() {
    this.userBillList();
    this.billTypeMap();
    this.billMethodMap();
  },
  methods: {
    // 可选交易方式
    billMethodMap() {
      this.$api.clienteleApi.billMethodMap(this.datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.billMethod = res.data
      })
    },
    // 获取可选账单类型列表
    billTypeMap() {
      this.$api.clienteleApi.billTypeMap(this.datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.billType = res.data
      })
    },
    // 重置
    reset() {
      this.datas = {
        user_id: '',
      };
      this.userBillList();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.userBillList();
    },
    // 获取配送单列表
    userBillList() {
      this.datas.user_id = this.user_id
      this.tableData = []
      this.$api.JapaneseOffice.userBillList(this.datas).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.userBillList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.userBillList();
    },
  },
};
</script>

<style lang='scss' scoped>
.search {

  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    display: flex;
    justify-content: center;
    align-items: center;

    * {
      margin-bottom: 26px;
    }
  }
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.flex05 {
  flex: 0.5;
}

.flex15 {
  flex: 1.5;
}

.flex2 {
  flex: 2;

}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.table {
  font-size: 14px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;


    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  ul {
    li {
      word-break: break-all;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;
  }

  .flex3 {
    flex: 3;
    overflow: hidden;
  }

  .flex15 {
    flex: 1.5;
  }

  .important {
    background-color: #e0e7f7;
    max-height: 100px;
    overflow: hidden;
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;


    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }
}

.showDetail {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  p {
    max-width: 86%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.btns {
  color: red;
  text-decoration: underline;
  background-color: transparent;
  margin: 0;
  padding: 0;
  cursor: pointer;
}
</style>
